import createReducer from '../utils/createReducer';
import ActionTypes from '../constants/ActionTypes';
import { combineReducers } from 'redux';

const list = createReducer(
  {},
  {
    [ActionTypes.FETCH_SITE_SUCCESS]: (state, { payload }) =>
      Object.assign({}, state, { [payload.key]: payload.site })
  }
);

const setStatusForKey = (state, { type, payload }) =>
  Object.assign({}, state, { [payload.key]: type });

const status = createReducer(
  {},
  {
    [ActionTypes.FETCH_SITE_REQUEST]: setStatusForKey,
    [ActionTypes.FETCH_SITE_SUCCESS]: setStatusForKey,
    [ActionTypes.FETCH_SITE_NOT_FOUND]: setStatusForKey,
    [ActionTypes.FETCH_SITE_ERROR]: setStatusForKey
  }
);

export default combineReducers({
  list,
  status
});
